import { AlertTriangle, RotateCw } from 'lucide-react'

interface Props {
  title?: string
  message?: string
  onRetry?: () => void
  requestId?: string
}

export function ErrorState({ title = 'Something went wrong', message, onRetry, requestId }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-danger/20 bg-danger-soft px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-danger">
        <AlertTriangle size={26} />
      </div>
      <h3 className="text-headline-sm font-semibold text-slate-800">{title}</h3>
      {message && <p className="max-w-md text-body-sm text-slate-600">{message}</p>}
      {requestId && <p className="font-mono text-label-sm text-slate-400">ref: {requestId}</p>}
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-1 inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-title-sm font-semibold text-white transition-shadow duration-180 hover:shadow-md"
        >
          <RotateCw size={15} /> Retry
        </button>
      )}
    </div>
  )
}
